import { Grid, Skeleton } from "@mui/material";

import ExecutiveKpiCard from "../ExecutiveKpiCard";
import { pick } from "../managementDashboardUtils";

const pickMoney = (metric) => {
  if (!metric) return null;
  const value = pick(metric, "value", "Value");
  const formatted = pick(metric, "formattedValue", "FormattedValue");
  if (formatted) return formatted;
  if (value == null) return null;
  return Number(value).toLocaleString("fa-IR");
};

const LendingKpiRow = ({ data, loading, error, onRetry }) => {
  const cards = [
    {
      title: "درخواست وام",
      value: data?.applicationsRequiringFinancing ?? data?.ApplicationsRequiringFinancing,
      unit: "متقاضی",
    },
    {
      title: "ارسال به لندتک",
      value: data?.sentToLendingPlatform ?? data?.SentToLendingPlatform,
      unit: "مورد",
    },
    {
      title: "اعتبارسنجی تأیید",
      value: data?.creditApproved ?? data?.CreditApproved,
      unit: "مورد",
    },
    {
      title: "تأیید نهایی",
      value: data?.loanProcessComplete ?? data?.LoanProcessComplete,
      unit: "مورد",
    },
    {
      title: "پرداخت شده",
      value: data?.financingDisbursed ?? data?.FinancingDisbursed,
      unit: "مورد",
    },
    {
      title: "مبلغ تأمین مالی",
      moneyMetric:
        data?.disbursedFinancingAmount
        ?? data?.DisbursedFinancingAmount
        ?? data?.approvedFinancingAmount
        ?? data?.ApprovedFinancingAmount,
    },
  ];

  if (loading) {
    return (
      <Grid container spacing={1.5} sx={{ mb: 2 }}>
        {cards.map((c) => (
          <Grid item xs={12} sm={6} md={4} lg={2} key={c.title}>
            <Skeleton variant="rounded" height={110} />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid container spacing={1.5} sx={{ mb: 2 }}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={4} lg={2} key={card.title}>
          <ExecutiveKpiCard
            kpi={{
              title: card.title,
              value: card.moneyMetric
                ? pick(card.moneyMetric, "value", "Value")
                : card.value,
              formattedValue: card.moneyMetric
                ? pickMoney(card.moneyMetric)
                : undefined,
              unit: card.moneyMetric ? "ریال" : card.unit,
              isAvailable: card.moneyMetric
                ? pick(card.moneyMetric, "isAvailable", "IsAvailable") !== false
                : card.value != null,
              metricType: 2,
              comparisonState: 3,
            }}
            loading={false}
            error={error}
            onRetry={onRetry}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default LendingKpiRow;
